import React from 'react';
import {
  formatCurrency,
  getCreatorName,
  getFundingGoalDisplay,
  getFundingProgress,
  getProjectTitle,
} from '../fundingUtils';

export default function FundingProjectList({ ideas, fundedIds, loading, onFund }) {
  if (loading) {
    return (
      <section className="funding-all" id="all-projects" aria-labelledby="all-projects-heading">
        <div className="funding-section-head funding-section-head--light">
          <h2 id="all-projects-heading">All Projects</h2>
        </div>
        <div className="funding-empty funding-empty--dark">Loading projects...</div>
      </section>
    );
  }

  if (ideas.length === 0) {
    return (
      <section className="funding-all" id="all-projects" aria-labelledby="all-projects-heading">
        <div className="funding-section-head funding-section-head--light">
          <h2 id="all-projects-heading">All Projects</h2>
        </div>
        <div className="funding-empty funding-empty--dark">No student ideas available right now.</div>
      </section>
    );
  }

  return (
    <section className="funding-all" id="all-projects" aria-labelledby="all-projects-heading">
      <div className="funding-section-head funding-section-head--light">
        <h2 id="all-projects-heading">All Projects</h2>
        <p>Browse every pitch and record your funding interest.</p>
      </div>
      <div className="funding-list">
        {ideas.map((idea, index) => {
          const isFunded = fundedIds.includes(idea._id);
          const progress = getFundingProgress(idea, fundedIds);
          const goal = getFundingGoalDisplay(idea);
          const raised = Math.round((goal * progress) / 100);

          return (
            <article key={idea._id || index} className="funding-item">
              <div className="funding-item-left">
                <div className="funding-item-badge">{idea.category || 'User/Talent'}</div>
                <h2>{getProjectTitle(idea, index)}</h2>
                {idea.note && <p className="funding-note">{idea.note}</p>}
                <p className="funding-meta">
                  By {getCreatorName(idea)} ·{' '}
                  {new Date(idea.uploadedAt || Date.now()).toLocaleDateString()}
                </p>
                <div className="funding-progress-wrap funding-progress-wrap--compact">
                  <div className="funding-progress-meta">
                    <span>{formatCurrency(raised)} of {formatCurrency(goal)}</span>
                    <span>{progress}%</span>
                  </div>
                  <div className="funding-progress-bar">
                    <div className="funding-progress-fill" style={{ width: `${progress}%` }} />
                  </div>
                </div>
              </div>
              <div className="funding-item-right">
                <button
                  type="button"
                  className={`fund-btn ${isFunded ? 'fund-btn--done' : ''}`}
                  disabled={isFunded}
                  onClick={() => onFund(idea)}
                >
                  {isFunded ? 'Funded' : 'Fund the project'}
                </button>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}
